import React from 'react';
import './styles.scss';

export const LineThrough = () => <div className='line-through' />
